import {
  ACTIVITY_CUR_PAGE,
} from '../mutation_type';

const state = {
  activityCurPage: "list",
};

const getters = {
  getActivityCurPage: state => state.activityCurPage,
};

const mutations = {
  [ACTIVITY_CUR_PAGE](state, activityCurPage) {
    state.activityCurPage = activityCurPage;
  },
};

export default {
  state,
  getters,
  mutations,
};
